import React from 'react';
import {Grid, Typography} from '@mui/material';
import {grey} from '@mui/material/colors';
import {formatDisplayTime, calculateTimeblockScheduledAndAvailableHours} from "../../helpers/ShiftPlanHelper";

const timeBlockWidthVw = 55/7;
const timeBlockMinWidthRem = 6.5;
const rowHeight = '1.5rem';

const styles = {
    header: {
        width: `${timeBlockWidthVw}vw`,
        height: rowHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: '0.0625rem solid #ccc',
        boxSizing: 'border-box',
        marginBottom: '0.25rem',
        minWidth: `${timeBlockMinWidthRem}rem`,
        padding: '0.125rem',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        fontWeight: 'bold',
        backgroundColor: grey[100],
        cursor: 'default'
    },
    availablePerformers: {
        color: grey[600],
        fontSize: '0.75rem',
        fontWeight: 'normal',
        paddingTop: '0.1rem',
    }
};

export default function ShiftPlanTimeblockHeader({ timeblocks, performerEnrollments, selectedDate, isReadOnly }) {
    return (
        <>
            {timeblocks.map((timeblock, idx) => (
                <Grid item key={idx} sx={styles.header}>
                    <Typography  variant="body2">
                        {formatDisplayTime(timeblock, selectedDate)}
                    </Typography>
                    {
                        !isReadOnly
                        &&
                        <Typography variant="body2" sx={styles.availablePerformers}>
                            ({calculateTimeblockScheduledAndAvailableHours(timeblock, performerEnrollments)})
                        </Typography>
                    }
                </Grid>
            ))}
        </>
    );
}